<template>
  <v-row >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="800px"
    >
      <template v-slot:activator="{ on, attrs }">
       
       <v-btn 
       v-bind="attrs"
          v-on="on"
          data-cy="add-imagenesBase-input"
       @click="imagenesBaseEdit" 
     icon
     class="ml-2"
       >
       <v-icon centered>mdi-pencil</v-icon></v-btn>
       
      </template>


      <v-card>
        
         <!-- INICIO DIALOG DATA -->

          <div class="my-2">
      <v-btn @click="dialogData = true">check data</v-btn>
    </div>

     <v-dialog
      v-model="dialogData"
    >
      <v-card>
    Principal Zoom
        {{this.principal.zoom}}

        ImagenesBase  - Clave: {{imagenesBaseData.id}}

        

        <v-card-title>ImagenesBase </v-card-title>

        <v-card-text class="pprint">{{imagenesBase}}</v-card-text>

        
        <v-card-title>PRINCIPAL </v-card-title>


        
       <v-card-text class="pprint">{{ principal }}</v-card-text>

        
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="info" text @click="dialogData = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
 


<!-- FIN DIALOG DATA -->
      
        
<v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                

                <v-card-text>
               <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
   
   
    <v-text-field
           v-model="imagenesBase.descripcion"
           label="Descripcion"
           :counter="2"
           :rules="textRules"
           required
         ></v-text-field>

            
 <v-text-field
           v-model="imagenesBase.tipo"
           label="Tipo"
         ></v-text-field>


<v-avatar
:size="zoom*2"
>
    
 <a data-fancybox data-caption="Single image" :href="server_url+'api/imagenes_base/get_imagenes_base/'+ imagenesBase.linkPhoto">
        <img :src="server_url +'api/imagenes_base/get_imagenes_base/'+imagenesBase.linkPhoto" style="height:20vh" />
      </a>

    </v-avatar>


    <v-card-text>
      <v-slider
        v-model="zoom"
        append-icon="mdi-magnify-plus-outline"
        prepend-icon="mdi-magnify-minus-outline"
        @click:append="zoomIn"
        @click:prepend="zoomOut"
         @input="onZoomChange"
      ></v-slider>
      <p>Zoom: {{zoom}}</p>
      <p>Zoom p: {{ imagenesBase.zoom }}</p>
    </v-card-text>


      <v-file-input
            v-if="!fileData.url"
            v-model="archivo"
            show-size
            chips
            label="Adjuntar Imagen"
            prepend-icon="mdi-file"
            @change="uploadFile"
            ref="file_perfil"
            data-cy="file-input"
          ></v-file-input>
          <div v-if="fileData.url">
            <p>Archivo Agregado</p>
            <span>
              <a :href="server_url +'api/imagenes_base/get_imagenes_base/'+ fileData.url">
                {{ fileData.name }}
                <v-icon color="blue">mdi-download</v-icon>
              </a>
              <button @click="removeFile()">
                <v-icon color="red">mdi-delete</v-icon>
              </button>
            </span>
          </div>




    <v-text-field
           v-model="imagenesBase.linkPhoto"
           label="Link_photo"
         ></v-text-field>

          <v-text-field
           v-model="imagenesBase.icon"
           label="Icon"
         ></v-text-field>
   
   
  
 <v-row no-gutters>
      
      <v-col>
      </v-col>

      <v-col order="last">
        
      </v-col>
     
    </v-row>


      
      <v-btn
        :disabled="!valid"
        color="success"
        class="mr-4"
        @click="registrarImagenesBase"
      >
        Registrar
      </v-btn>

      <v-btn
        color="error"
        class="mr-4"
        @click="dialog = false"
      >
        Cancelar
      </v-btn>
  
    </v-form> 
            </v-card-text>
               


              </v-col>
              
            </v-row>
          </v-container>
        </v-card-text>


      
      </v-card>




    </v-dialog>
  </v-row>
</template>




<script>

import imagenesBaseService from "@/services/imagenesBaseService.js";


import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';


import { http } from "@/services/config";


 
export default {

   props: {
    imagenesBaseData: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    },
    principal: {
      type: Object, // Tipo de dato correspondiente al objeto del autor
      default: () => ({}) // Valor por defecto, un objeto vacío si no se proporciona
    }
  },
 
  data: vm => ({
     zoom: 50,
  //<td v-on:click="guardarImagenesBase(imagenesBase)">{{imagenesBase.name}}</td>
  valid: true,
  dialog:false,
  dialogData:false,
    errors: "",
    showError: false,
    imagenesBases: [],
    buscador:'',
     refreshImage: false,
     selectedFile:null,
     UploadValue:0,
     picture:null,
     file: null,


     
      server_url: "",
      valid: false,
      archivo: null,
      fileData: {
        downloadUri: "",
      },
    imagenesBase:{
id:'',
descripcion:'',
tipo:'',
linkPhoto:'',
icon:''


          
        },
  
    rules: {
                  required: value => !!value || 'Campo Requerido',
                  min: v => v.length >= 5 || 'Minimo 5 caracteres',
                  emailMatch: () => (`The email and password you entered don't match`),
                },
        	messages:undefined,
        
        
        
         textRules: [
              (v) => !!v || "Campo es requerido",
              (v) => (v && v.length >= 1) || "Debe contener al menos 3 caracteres",
            ],
        
            emailRules:  [
              (v) => !!v || "Correo es requerido",
              (v) => /.+@.+\..+/.test(v) || "Correo debe ser valido",
            ],
             numberRules: [
              (v) => (v >= 0) || "Valor debe ser mayor o igual a 0",
            ],
  }),
  components:{
    //  CloudImage
  },
  mounted() {
   

 Fancybox.bind(this.$refs.container, '[data-fancybox]', {
      ...(this.options || {}),
    });

     this.server_url = http.defaults.baseURL;


  },
  methods: {

    imagenesBaseEdit(){
      console.log(this.imagenesBaseData);
      this.imagenesBase=this.imagenesBaseData;
    },
    listar() {
      imagenesBaseService
        .listar()
        .then((resposta) => {
          console.log(resposta.data);
          this.imagenesBases = resposta.data;
         
        })
        .catch((e) => {
          this.errors = e.response.data.errors;
        });
    }, 
    registrarImagenesBase:function(){

            if (this.$refs.form.validate()) {

              let res;
    this.redirect='/imagenes_base';

    this.imagenesBase.principal=this.principal;
    console.log(this.imagenesBase);

    imagenesBaseService.update(this.imagenesBase).then(
        response =>{
            res= response.data.status,
            console.log('success');

            console.log(response);
          //  setTimeout( 
             //   ()=> (this.redirect !=='') ? window.location.href = this.redirect:''
             //   ,2000)
        }).catch((errors) =>{
          //  let desc='';
         //   res = errors.response.data.status;
         //   errors.response.data.errors.map( (e) =>{ desc= desc+' '+e})
           console.log('error');
            console.log(errors);

//console.log(errors.message);
           
        })
        console.log(res);


            }


      //console.log(imagenesBase);
            this.$emit('imagenesBaseEdit',this.imagenesBase);
            this.dialog=false;
        },
    validate(){
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
    //  this.$refs.form.reset();
      this.limpiar();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
    ,
    limpiar(){

     
		this.imagenesBase={
				descripcion:'',
        tipo:'',
				linkPhoto:'',
				icon:'',
				
	}
    }
  ,
    uploadFile: function () {
      this.imagenesBase.linkPhoto=this.fileData.url;
      if (this.archivo) this.submitFile();
      else this.removeFile();
    },
    submitFile() {

      this.fileData.name=this.archivo.name;
      console.log(this.archivo);
      const formData = new FormData();
      formData.append("file_imagenesBase", this.archivo);
      formData.append("imagenesBase", JSON.stringify(this.imagenesBase));
    //  formData.append('data', this.imagenesBase);
      //formData.append("identificador", this.principal.identificador);
      formData.append("imagenesBase_id", this.imagenesBase.id);
      const headers = { "Content-Type": "multipart/form-data" ,
      'Authorization':'Bearer '+ localStorage.getItem("token")};
      console.log(formData);
      http
        .post(this.server_url + "api/imagenes_base/save_imagenes_base/"+this.imagenesBase.id, formData, { headers })
        .then((res) => {
          
         this.imagenesBase.linkPhoto=res.data.imagenesBase.linkPhoto;
         this.fileData.url=res.data.imagenesBase.linkPhoto;

         console.log(this.imagenesBase.linkPhoto);
        });
    },
    removeFile() {
        this.fileData = { url: "" };
      
        this.archivo=null;

        this.imagenesBase.linkPhoto='';
  
    },
    zoomOut () {
        this.zoom = (this.zoom - 20) || 0
      },
      zoomIn () {
        this.zoom = (this.zoom + 20) || 200
      },
      onZoomChange(value) {
     // console.log('Zoom cambiado a:', value);
      this.imagenesBase.zoom=value;
    }
           
  },//fin methos

  computed: {
      pprint: {
      get () { return JSON.stringify(this.opcions, undefined, 4)}
    }
      
    },

    watch: {

       // Watcher para monitorear cambios en imagenesBase.zoom
     'imagenesBase.zoom'(newZoom) {
      this.zoom = newZoom;
    }
      
    },




}
    
  
</script>

<style scoped>

.pprint {
  white-space:pre-wrap;
  word-wrap:break-word;
}
</style>